var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e,.f{fill:none;}.g{fill:#ffaa50;}.h{clip-path:url(#d);}.f{stroke:#841a0c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.32px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M21.87,23.39c0-2.86-1.95-5.25-4.59-5.95,1.22-.59,2.08-1.83,2.08-3.28,0-2.01-1.63-3.65-3.65-3.65s-3.65,1.63-3.65,3.65c0,1.45,.85,2.69,2.08,3.28-2.64,.7-4.59,3.09-4.59,5.95"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M27.18,19.34c0-2.9-2.24-5.28-5.09-5.51,1.49-.31,2.62-1.63,2.62-3.21,0-1.81-1.47-3.28-3.28-3.28-1.24,0-2.3,.69-2.86,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M4.24,19.34c0-2.9,2.24-5.28,5.09-5.51-1.49-.31-2.62-1.63-2.62-3.21,0-1.81,1.47-3.28,3.28-3.28,1.24,0,2.3,.69,2.86,1.7"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.2ecbfc4d8ffe13f8d49a217853c59f84.svg";
export { ForwardRef as ReactComponent };